import { Reveal, Overline } from "./Reveal";
import { Check } from "lucide-react";
import { MEDIA } from "../data/content";

export const Market = ({ t }) => (
  <section id="market" data-testid="market-section" className="relative py-24 md:py-36 bg-copou-ink text-white overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      <Reveal>
        <Overline>{t.market.overline}</Overline>
        <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight mt-4 text-white">{t.market.title}</h2>
        <p className="mt-7 text-white/70 leading-relaxed text-base md:text-lg">{t.market.text}</p>

        <div className="mt-12 grid grid-cols-3 gap-6 border-t border-white/15 pt-10">
          {t.market.stats.map((s, i) => (
            <div key={i} data-testid={`market-stat-${i}`}>
              <div className="font-serif text-5xl md:text-6xl text-copou-primary leading-none">{s.v}</div>
              <div className="text-[11px] md:text-xs uppercase tracking-wider text-white/60 mt-3">{s.l}</div>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.12}>
        <div className="relative">
          <img src={MEDIA.university} alt="Arhitectură academică în Copou" className="w-full h-72 md:h-80 object-cover mb-8" />
          <p className="text-xs uppercase tracking-[0.2em] text-copou-primary mb-5">{t.market.servicesTitle}</p>
          <ul className="space-y-3">
            {t.market.services.map((s, i) => (
              <li key={i} className="flex items-start gap-3 text-white/85">
                <Check size={18} className="text-copou-primary mt-1 shrink-0" />
                <span>{s}</span>
              </li>
            ))}
          </ul>
        </div>
      </Reveal>
    </div>
  </section>
);
